query AnalyticsSalesByProvider($filter: AnalyticsSalesFilterInput!) {
  analyticsSales(filter: $filter) {
    currency
    salesByProvider {
      provider
      sales
      revenue
    }
  }
}
